module.exports = __webpack_public_path__ + "img/overnight_logo.bc3c1061.svg";